<div *ngIf="!formElement.hidden" [ngClass]="rowClass">
	<!-- <div class="row"> -->
	<label [for]="formElement.name" [ngClass]="labelClass">
		{{formElement.label}}
		<span class="mandatoryColor" *ngIf="(formElement.label) && (formElement.required || formElement.showAstrisk) && !formElement.silentRequired">*</span>
	</label>
	<div [ngClass]="inputClass">
		<ng-container *ngIf="!formElement.disabled">
			<app-geo-location (geoData)="setGeoLocation($event)"></app-geo-location>
			<p *ngIf="selectedLocation">{{selectedLocation}}</p>
		</ng-container>
		<ng-container *ngIf="formElement.disabled">
		<!-- <ng-container *ngIf="formElement.disabled" (click)="openInMap()"> -->
			<input type="text" disabled class="form-control m-input justify-text" [value]="selectedLocation">
		</ng-container>
		<span *ngIf="formElement.metainfo" class="m-form__help">
			{{formElement.metainfo}}
		</span>
	</div>
	<ng-container *ngIf="!formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div [ngClass]="inputClass">
			<ng-content></ng-content>
		</div>
	</ng-container>
	<ng-container *ngIf="formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div class="min-height-20">

		</div>
	</ng-container>

</div>
